import { Flex, Box, Text } from '@chakra-ui/react';
import { useUIStore } from '#store';
import { useLoadingMonitor } from 'src/hooks/useLoadingMonitor';

export default function Loading(props) {
  const loading = useUIStore((state) => state.loading);
  const loadingMessage = useUIStore((state) => state.loadingMessage);
  const isLoading = props.loading ?? loading;
  const { mode = 'full' } = props;

  // Monitor loading times and report to Rollbar if > 6 seconds
  useLoadingMonitor(isLoading);

  const modes = {
    full: {
      position: 'absolute',
      w: '100vw',
      h: '100vh',
      minH: '100%',
      align: 'center',
      justify: 'center',
      bgColor: 'rgb(0,0,0, 0.3)',
    },
    control: {
      zIndex: 1,
      position: 'absolute',
      w: '100%',
      justify: 'center',
      align: 'center',
    },
  };
  const containerStyle = {
    display: isLoading ? 'flex' : 'none',
    zIndex: 5,
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  };
  return (
    <Box {...containerStyle}>
      <Flex {...modes[mode]} {...(props?.style ?? {})}></Flex>
      <div className="loadingio-spinner-ellipsis-pa8ucpmzvc">
        <div className="ldio-ik502s7n6fp">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
      {loadingMessage && (
        <Text
          color="brand.800"
          fontSize="xl"
          fontWeight="bold"
          letterSpacing={'0.05em'}
          mt={'80px'}
          textAlign="center"
          zIndex={20}
          position="relative"
        >
          {loadingMessage}
        </Text>
      )}
    </Box>
  );
}
